import { render, staticRenderFns } from "./salesReport.vue?vue&type=template&id=641d920c&scoped=true&"
import script from "./salesReport.vue?vue&type=script&lang=js&"
export * from "./salesReport.vue?vue&type=script&lang=js&"
import style0 from "./salesReport.vue?vue&type=style&index=0&id=641d920c&lang=scss&scoped=true&"
import style1 from "./salesReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d920c",
  null
  
)

export default component.exports